nodeMarquee({
  parent: '.marquee',
  speed: 1
});


nodeMarquee({
  parent: '.marquee_home',
  speed: 1
});


    nodeMarquee({
  parent: '.marquee_product',
  speed: 1
});
    $(document).ready(function() {
      // Get the current URL path
      var currentPath = window.location.pathname;

      // Loop through each tag-item and check if it matches the current URL
      $('#BlogTagFilter .tag-item').each(function() {
        var tagUrl = $(this).find('a').attr('href');
        
        // If the current URL matches the tag URL or contains the tag, add the 'active' class
        if (currentPath === tagUrl || currentPath.includes($(this).data('tag'))) {
          $(this).addClass('active');
        }
      });

      // When a tag-item is clicked
      $('#BlogTagFilter .tag-item').on('click', function() {
        // Remove 'active' class from all tag-items
        $('#BlogTagFilter .tag-item').removeClass('active');
        
        // Add 'active' class to the clicked tag-item
        $(this).addClass('active');
      });
    });




  $(document).ready(function() {
    // Add all h3 headings to article_call_head
    $('.blog_text_style').each(function(index) {
      var headingText = $(this).text(); // Get the text of the heading
      var id = 'heading-' + index;
      $(this).attr('id', id); // Add an ID to each h3
      $('.article_call_head').append('<a href="#' + id + '">' + headingText + '</a>');
    });

    // Handle scrolling and highlight the active heading
    $(window).on('scroll', function() {
      var scrollPos = $(window).scrollTop();
      
      $('.blog_text_style').each(function() {
        var headingOffset = $(this).offset().top - 50; // Adjust for sticky header
        var headingId = $(this).attr('id');
        
        if (scrollPos >= headingOffset) {
          // Remove active class from all links
          $('.article_call_head a').removeClass('active');
          // Add active class to the current heading link
          $('.article_call_head a[href="#' + headingId + '"]').addClass('active');
        }
      });
    });
  });












$('.about_testimonial').slick({
  dots: false,
  infinite: true,
  fade: true,
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true
});




// Adding margin to each slide
$('.blog__posts_2 .slick-slide').css('margin', '0px');


$(function() {
  
  $(".js-faq-title").first().addClass("faq__active"); 
  $(".js-faq-content").first().slideDown(0); 
  $('.js-faq-rotate').first().addClass('faq__rotate'); 
  
  $(".js-faq-title").on("click", function(e) {
    e.preventDefault();
    var $this = $(this);

    if (!$this.hasClass("faq__active")) {
      $(".js-faq-content").slideUp(800);
      $(".js-faq-title").removeClass("faq__active");
      $('.js-faq-rotate').removeClass('faq__rotate');
    }

    $this.toggleClass("faq__active");
    $this.next().slideToggle();
    $('.js-faq-rotate', this).toggleClass('faq__rotate');
  });
  //END

});


    // JavaScript code
  function search_animal() {
      let input = document.getElementById('searchbar').value
      input=input.toLowerCase();
      let x = document.getElementsByClassName('faq__item');

      for (i = 0; i < x.length; i++) {
          if (!x[i].innerHTML.toLowerCase().includes(input)) {
              x[i].style.display="none";
          }
          else {
              x[i].style.display="";
          }
      }
  }

$('ul.tabs li').click(function(){
      var tab_id = $(this).attr('data-tab');
      $('ul.tabs li').removeClass('current');
      $('.tab-content').removeClass('current');
      $(this).addClass('current');
      $("#"+tab_id).addClass('current');
    });
    $(document).on("click",'.tabber_mbl .tabber_mbl_heading',function(){
       $('.tabber_mbl').removeClass('active');
       $(this).parent().toggleClass('active');
    });
     $(document).on("click",'.tabber_mbl.active .tabber_mbl_heading',function(){
      $('.tabber_mbl.active').toggleClass('active');
    });


  $('#coll_filter li a').on('click', function() {
    $('#coll_filter li a').removeClass('active');
    $(this).addClass('active');
});


$(document).ready(function() {
    $(".references_section ol li").slice(3).hide();
    $(".references_section .show-less-Ic").hide();
    $(".references_section .refer-IC-bn").click(function() {
        $(".references_section ol li").show();
        $(this).hide();
        $(".references_section .show-less-Ic").css("display", "block");
    });
     $(".references_section .show-less-Ic").click(function() {
       $(".references_section ol li").slice(3).hide();
       $(".references_section .show-less-Ic").hide();
       $(".references_section .show-less-Ic").css("display", "none");  
        $(".references_section .refer-IC-bn").css("display", "block");
    });
});
